<template>
  <div style="min-height: 230px;">
    <div v-if="dataReady" id="y-product-attributes-wrapper">
      <div id="y-product-attributes">
        <div v-if="Object.keys(selectableAttributes).length > 0 && product.configurations.length > 1" class="y-clear-filters">
          <div class="attribute-button" @click="resetSelectedAttributes()">Clear filters <span class="dashicons dashicons-image-rotate"></span></div>
        </div>
        <div v-for="(values, key) in selectableAttributes" class="y-attribute">
          <div v-show="values.length > 1 || showSingle">
            <h4 class="y-product-code"><b>{{ key }}:</b></h4>
            <div class="y-select-attribute">
              <div v-for="val in values"
                  :class="{'attribute-button': true, 'selected': selectedAttributes[key] === val, 'highlight': (highlight[key] ? highlight[key].includes(val) : null)}"
                  @mouseover="( highlightMatching(true, key,val))"
                  @mouseout="(unhighlight())"
                  v-on:click="selectAttribute(key,val)">
                {{ val }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.options.length > 0" class="y-options-wrapper">
        <hr>
        <h3 class="y-title">Options</h3>
        <div v-for="option in options">
          <div v-if="selectedOptions[option.name]" class="y-option">
            <h4 class="y-product-code"><b>{{ option.name }}:</b> {{
                selectedOptions[option.name].value
              }} <a
                  v-on:click="removeOption(option.name)" class="btn btn-default btn-sm">Change</a></h4>
          </div>
          <div v-else class="option">
            <h4 class="y-product-code"><b>{{ option.name }}:</b></h4>
            <div class="select-attribute">
                                      <span v-for="val in option.values">
                                          <input :id="val.value"
                                                type="radio"
                                                v-model="selectedOptions[option.name]"
                                                v-bind:value="val"
                                                class="subCategoryThumb"
                                          >
                                          <label :for="val.value"
                                                class="thumbnail"
                                          >
                                              {{ val.value }} +£{{ val.price | money }}
                                          </label>
                                      </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="(this.accessories.length > 0)" class="accessories-wrapper">
          <hr>
        <h3 class="y-title">Accessories</h3>
        <div v-for="accessoryGroup in accessories" class="accessory">
          <div v-if="selectedAccessories[accessoryGroup.name]">
            <h4 class="product-code"><b>{{ accessoryGroup.name }}<span
                v-if="accessoryGroup.is_required" class="required">*</span>:</b>
              {{ selectedAccessories[accessoryGroup.name].accessory.name }} x
              {{ selectedAccessories[accessoryGroup.name].count }} <a
                  v-on:click="removeAccessory(accessoryGroup.name)">Change</a>
            </h4>
          </div>
          <div v-else>
            <h4 class="text-capitalize product-code"><b>{{ accessoryGroup.name }}<span
                v-if="accessoryGroup.is_required" class="required">*</span>:</b></h4>
            <div class="select-attribute">
              <div v-for="(item, index) in accessoryGroup.items" :key="index">
                <div v-if="item.accessory">
                  <input :id="item.accessory.name + index"
                        type="radio"
                        :data-count="item.count"
                        v-model="selectedAccessories[accessoryGroup.name]"
                        v-bind:value="accessoryGroup.items[index]"
                        class="subCategoryThumb">
                  <label :for="item.accessory.name + index" class="thumbnail">{{
                      item.accessory.name
                    }} (x{{ item.count }}) +£{{
                      item.price * item.count | money
                    }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="y-product-price">
        <div class="m-t-10">
          <label>Ex. VAT</label>
          <label class="switch" name="">
            <input label="VAT Checkbox" type="checkbox" :checked="vatToggle" @click="updateVatToggle">
            <span class="slider round"></span>
          </label>
          <label>Inc. VAT</label>
        </div>
        <div>
          <span class="y-price-sales">{{ !product.sku ? 'From' : '' }} £<span v-if="product.poa == 1">POA</span><span v-else>{{ viewPrice | money }}</span></span>
          <span v-if="product.poa != 1" class="price-tag"> per {{ product.unit_per_sale }} {{ !vatToggle ? 'excluding':'including' }} VAT.</span>
        </div>
        <div v-if="product.poa != 1">
          <span class="y-price-sales">£{{ animatedPrice | money }}</span>
          <span class="price-tag">total {{ !vatToggle ? 'excluding':'including' }} VAT, <a href="#delivery" class="show-delivery-costs">delivery costs</a> may apply.</span>
        </div>
        <div v-if="product.sales_discounts.length > 0" style="margin-top: 5px;">
          <table class="table table-hover">
            <tbody>
              <th>From</th>
              <th>To</th>
              <th>Price</th>
              <tr v-for="entry in product.sales_discounts">
                <td v-if="entry.to_count > 0">{{ entry.from_count }}</td>
                <td v-else>{{ entry.from_count }}+</td>
                <td v-if="entry.to_count > 0">{{ entry.to_count }}</td>
                <td v-else></td>
                <td>£{{ discountedItemPrice(entry.price) | money }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <form v-if="product.is_sell_online && product.poa != 1">
          <VTooltip v-if="!product.sku || disabled" class="yodah-flex-container m-t-10">
            <div class="flex-70">
              <input :disabled="!product.sku || disabled"
                    type="number"
                    class="form-control input"
                    placeholder="Quantity (please select options above first)"
              />
            </div>
            <div class="flex-30">
              <button disabled class="y-btn y-basket-btn flex-100">Add to basket</button>
            </div>
            <template #popper>
              Please select options before you can add to the basket
            </template>
          </VTooltip>
          <div v-else class="yodah-flex-container m-t-10">
            <div class="flex-70">
              <input required type="number"
                     :min="product.min_sale_count"
                     :max="500"
                    class="form-control input"
                    placeholder="Quantity"
                    v-model="quantity"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="quantity"
                    v-validate="{min_value:(product.min_sale_count?product.min_sale_count:0), max_value:500}"
                    style="margin-bottom:0"
              />
            </div>
            <input type="hidden"/>
            <div class="flex-30">
              <button class="y-btn y-basket-btn flex-100" v-on:click.prevent="addToBasket">Add to basket</button>
            </div>
          </div>
          <div v-if="ppClientId" class="y-pp-finance" data-pp-message data-pp-style-layout="text" data-pp-style-logo-type="inline" data-pp-style-text-color="black" :data-pp-amount="totalPrice + totalTax"></div>

          <div v-show="msg" class="y-modal fade in">
                <div v-on:click="" class="y-modal-dialog  y-modal-bg-1 fade in" >
                    <div v-show="msg" style="display:flex; justify-content:space-between">
                      <h4 style="font-size:20px;"><b><i class="fa fa-check-circle" style="color:green"></i> Added to basket</b></h4>
                      <i v-on:click="msg=''" class="fa fa-times" style="font-size:20px; cursor: pointer;"></i>
                    </div>
                    <table>
                      <tr>
                        <td class="text-right p-r-5"><h4><b>Item: </b></h4></td>
                        <td><h4>{{ $store.state.currentProduct.name }}</h4></td>
                      </tr>
                      <tr>
                        <td class="text-right p-r-5"><h4><b>Basket total: </b></h4></td>
                        <td><h4>£{{ $store.state.basketValues.gross | money }}</h4></td>
                      </tr>
                    </table>
                    <div style="display:flex; justify-content: flex-end; align-items: flex-end;">
                      <a v-on:click="msg=''" style="margin-right:5px; color:gray; text-decoration: underline;">Continue Shopping</a>
                      <a href="../../basket/" class="btn btn-inverse">Proceed to Checkout <i class="fa fa-arrow-circle-right"></i></a>
                    </div>
                </div>
                <div v-on:click="msg=''" class="y-modal-backdrop" ></div>
            </div>
          <p v-show="errors.has('quantity')" class="control has-icon has-icon-right qty-error"><i class="fa fa-warning"
                                                                                                  style="color: #E74C3C;"></i>
            <span class="help has-error"> {{ errors.first('quantity') }}</span></p>
        </form>
        <div v-else class="cannot-buy-online">{{ (notAvailableText ? notAvailableText : 'This product is not available to buy online.') }}{{ (contact ? ' Click quick quote below to continue.' : '') }}</div>
        <div v-if="product.availability">
          <p class="availability">Availability: {{ product.availability }}</p>
        </div>
        <div v-if="product">
          <div>
            <a v-for="file in product.common_files" class="btn btn-info btn-lg m-t-10 btn-block"
              :title="'Download' + file.original_name" :href="'/uploads/products/' + file.name" target="_blank"
              rel="noopener"><i class="glyphicon glyphicon-download-alt"></i> Download {{ file.original_name }}</a>
            <a v-for="file in product.files" class="btn btn-info btn-lg m-t-10 btn-block"
              :title="'Download' + file.original_name" :href="'/uploads/products/' + file.name" target="_blank"
              rel="noopener"><i class="glyphicon glyphicon-download-alt"></i> Download {{ file.original_name }}</a>
          </div>
        </div>
        <button v-if="contact" class="btn btn-primary btn-lg btn-block m-t-15" data-target="#how-to-order-modal"
                data-toggle="modal"><i class="fa fa-question-circle"></i> Quick quote
        </button>
        <product-contact-modal v-if="contact" :sku="product.sku" :options="selectedOptions"
                              :accessories="selectedAccessories" :product="product" :email="email" :tel="tel"
                              :telString="telString" :openingHours="openingHours" :yodahURL="yodahURL"></product-contact-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TweenLite from 'gsap';
import {mapState} from 'vuex';
import {calculateItemPrice} from './mixins/calculateItemPrice';
import {loadScript} from "@paypal/paypal-js";
//import ProductContactModal from "../assets/js/components/products/ProductContactModal.vue";

export default {
  el: '#product-selector',
  mixins: [calculateItemPrice],
  components: {
  //ProductContactModal
  ProductContactModal: () => import(/* webpackChunkName: "ProductContactModal" */ '../assets/js/components/products/ProductContactModal.vue')
  },
  data() {
    return {
      dataReady: false,

      // accessories
      accessories: [],
      accessoriesForProduct: [],

      //attributes
      matchingProducts: {}, // holds matching based upon currently selected attributes
      selectedAttributes: {}, // selected attributes -> set if product page loaded, updated when an attribute is clicked...
      selectableAttributes: {}, // all unique attributes for all products
      unselectedAttributes: {}, // unselected attribute keys, true if not yet selected (is this needed, could just go on whther ther is a selected value..?

      highlight: {}, // list of attributes to highlight -> updates whenever mouseover/away

      configurations: [],
      currentProductId: jQuery("#data-product").data("product"),
      freeShipping: jQuery("#data-product").data("free-shipping"),
      matchingConfigurations: {},
      msg: '',
      notAvailableText: jQuery("#data-product").data("content"),
      options: [],
      parentId: 0,
      ppClientId: jQuery("#data-product").data("pp-client-id"),
      product: {},
      quantity: '',
      requiredOptions: 0,
      requiredAccessories: 0,
      selectedOptions: {},
      selectedAccessories: {},
      shippingCalculation: jQuery("#data-product").data("shipping-calculation"),
      showSingle: jQuery("#data-product").data("show-single"),
      tweenedPrice: 0,
      salesDiscounts: [],

      // contact form stuff
      contact: jQuery("#data-product").data("contact"),
      email: jQuery("#data-email").data("email"),
      tel: jQuery("#data-tel").data("tel"),
      telString: jQuery("#data-tel").data("tel"),
      openingHours: jQuery("#data-tel").data("open"),
      yodahURL: jQuery("#data-yodah-url").data("url")
    }
  },
  methods: {
    updateVatToggle() {
      this.$store.commit('updateVatToggle', !this.vatToggle);
    },
    // runs when the component is mounted
    // sets selectableAttributes and default unselectedAttributes
    async setupAttributes() {
      // if loading a products page then load the products attributes as selectedAttributes
      if(Object.keys(this.product.attributes).length > 0){
        this.selectedAttributes = this.product.attributes;
      }
      this.configurations.forEach((configuration, index) => {
        Object.keys(configuration['attributes']).forEach((key) => {
          if(!this.selectedAttributes[key]){
            this.$set(this.selectedAttributes, key, "");
          }
          if(!this.selectableAttributes[key]){
            this.selectableAttributes[key] = [];
            this.unselectedAttributes[key] = true;
          }
          if(!this.selectableAttributes[key].includes(this.configurations[index].attributes[key])){
            this.selectableAttributes[key].push(this.configurations[index].attributes[key]);
          }
        });
      });

      Object.keys(this.selectableAttributes).forEach((attribute) => {
        this.selectableAttributes[attribute].sort(function (a, b) {
          return ('' + a).localeCompare(b, 'en', { numeric: true });
        });
      })
      await this.updateUnselectedAttributes();
      await this.autoSelectAttributes();
      await this.findMatching();
      await this.checkSelectedProduct();
    },

    scroll() {
      if(document.referrer.includes("/product/")) {
        window.scrollTo({top: this.scrollY, behavior: 'auto'})
      }
    },

    // populates this.matchingProducts based upon the current selected attributes
    // also allows hovered value to be included
    findMatching(highlight = false, key, value) {
      // console.log('highlight', highlight);
      let selectedAtt = {} ;
      if(highlight){
        selectedAtt[key] = value;
      } else {
        selectedAtt = {...this.selectedAttributes}
      }
      // show the products that match the current selected attributes
      this.matchingProducts = this.configurations;
      // console.log('selectedAtt', selectedAtt);
      Object.keys(selectedAtt).forEach((attribute) => {
        if(selectedAtt[attribute] !== ""){

            this.matchingProducts = this.matchingProducts.filter((product) => {
            // console.log('attribute', attribute);
            // console.log('product', product);
            // console.log('true?', product.attributes[attribute] === selectedAtt[attribute]);
            return product.attributes[attribute] === selectedAtt[attribute];
          });
          // console.log('attribute', attribute);
          // console.log('matchingproducts', this.matchingProducts);
        }
      });
    },

    // checks if a product has been selected and redirects if so
    async checkSelectedProduct() {
      if (this.matchingProducts.length === 1 && (this.matchingProducts[0].sku !== this.product.sku)) {
        //reload page with new id or you can refresh data with this.selectedProduct data
        this.$store.commit('updateScrollY', window.scrollY);
        // console.log('product found - going to new product page...');
        document.body.style.cursor = 'wait';
        document.location.href = '/product/' + this.matchingProducts[0].slug;
      }
    },

    // updates the unselectedAttributes with true/false
    updateUnselectedAttributes(){
      Object.keys(this.selectedAttributes).forEach((attribute) => {
        this.unselectedAttributes[attribute] = !this.selectedAttributes[attribute];
      })
    },

    // when a new attr is selected, deselect any non-compatible attributes
    deselectImpossible(key, value){
      this.findMatching();
      if(this.matchingProducts.length === 0) {
        this.resetSelectedAttributes();
        this.$set(this.selectedAttributes, key, value);
        this.autoSelectAttributes()
      }
    },

    unhighlight() {
      if(this.selectedAttributes.length === 0) {
        this.highlight = {};
      }
    },

    // runs whenever an attribute is clicked
    async selectAttribute(key, value) {
      await this.$set(this.selectedAttributes, key, value);
      await this.deselectImpossible(key, value);
      await this.findMatching(false, key, value);
      // await this.highlightMatching(true, key, value);
      await this.updateUnselectedAttributes();
      this.autoSelectAttributes()
      await this.updateUnselectedAttributes();
      await this.checkSelectedProduct();
    },

    async highlightMatching(select = false, key, value) {
      // using local var and then applying to vue to avoid issues
      // with reactivity not working on the vue observer object
      let highlight = {};
       await this.findMatching(select, key, value);
       // if(jQuery.isEmptyObject(this.matchingProducts)) return;
       this.matchingProducts.forEach((product) => {
        Object.keys(product.attributes).forEach((attribute) => {
          if (!highlight.hasOwnProperty(attribute)) {
            // add the empty attribute array to highlight
            highlight[attribute] = [];
          }
          // add the product attribute values to the new reactive array
          if(highlight[attribute][0] !== product.attributes[attribute]) {
            if(!highlight[attribute].includes(product.attributes[attribute]))
             highlight[attribute].push(product.attributes[attribute]);
          }
        })
      })
      this.highlight = highlight;
    },

    // runs when an attribute is selected // todo - possibly remove this, it is not being run..?
    reduceSelectableAttributes() {
      Object.entries(this.selectableAttributes).forEach(([key, value]) => {
        if (value.length === 1) {
          this.$set(this.selectedAttributes, key, this.selectableAttributes[key][0]);
          // this.fixedAttributes[key] = value[0]; // this is not used for some reason?
        } else if (value.length > 1) {
          this.selectableAttributes[key] = value;
        }
      });
    },

    // if remaining attribute only has one matching value with current selection then select it
    // works when a product is selected and there are other highlighted values
    // this.highlightMatching();
    autoSelectAttributes() {
        Object.keys(this.unselectedAttributes).forEach(attr => {
          if(this.unselectedAttributes[attr]) {
            // this works to select single attributes
            if(this.selectableAttributes[attr].length === 1) {
              this.$set(this.selectedAttributes, attr, this.selectableAttributes[attr][0])
            }
            this.highlightMatching();

            // selects attribute where it is the only option that works
            if(this.highlight[attr]) {
              if (this.highlight[attr].length === 1) {
                this.$set(this.selectedAttributes, attr, this.highlight[attr][0]);
              }
            }
          }
        })
    },

    // remove all attributes & redirect to parent page (if set)
    resetSelectedAttributes() {
      Object.keys(this.selectableAttributes).forEach(attr => {
        this.$set(this.selectedAttributes, attr, '');
        this.$set(this.highlight, attr, []);
      })
      this.updateUnselectedAttributes();
      if(this.product.parent_id) {
        //goto parent product page
        this.$store.commit('updateScrollY', window.scrollY);
        // console.log('product found - going to new product page...');
        document.body.style.cursor = 'wait';
        document.location.href = '/product/' + this.product.parent_slug;
      }
    },

    // BASKET METHODS

    async addToBasket() {
      let result = await this.$validator.validateAll();
      if (!result) {
        console.log('validation error', result);
        return false;
      }
      this.addAccessoriesToBasket();
      let options = '';
      Object.keys(this.selectedOptions).forEach((option) => {
        options += ' Option: ' + option + ": " + this.selectedOptions[option].value + " £" + this.selectedOptions[option].price + ' (included in item price).';
      });
      this.$store.commit('updateShippingCalculation', this.shippingCalculation);
      this.$store.commit('updateFreeShipping', this.freeShipping);
      // console.log('selected options before add to basket', {...this.selectedOptions});
      this.$store.dispatch('addItemToBasket', {
        product: {
          sku: this.product.sku,
          name : this.product.name,
          desc : this.product.short_description + (options ? options : ''),
          quantity : this.quantity,
          // options : {...this.selectedOptions},
          // accessories : {...this.selectedAccessories},
          itemPrice: this.itemPrice,
          itemTax: this.itemTax,
          totalPrice: this.totalPrice,
          totalTax: this.totalTax,
          taxRate: this.product.tax_rate,
          taxDesc: this.product.tax_text,
          sale_price: this.product.sale_price,
          sales_discounts: this.product.sales_discounts,
          selectedAccessories: {...this.selectedAccessories},
          selectedOptions: {...this.selectedOptions},
          slug: this.product.slug,
          shipping: this.product.shipping.values,
          parentId: this.product.parent_id,
          minSaleCount: this.product.min_sale_count,
          id: this.product.id
        },
        accessories: this.accessoriesForProduct
      }).then(() => {
        this.gaAddToBasket();
        this.ga4AddToBasket();
        this.msg = 'Added to basket. <a href="/basket">View basket</a>';
        // return this.$notify({ title: 'Success', text: 'Added to basket.'});
      }).catch((error) => {
        console.log('Error adding to basket!');
        // return this.$notify({ type: 'error', text: 'There was a problem: ' + error});
      });
    },


    // OPTIONS & ACCESSORIES METHODS
      addOption(option) {
        this.$set(selectedOptions, option.key, option.value);
      },
    // adds not required option
    addNotRequired(options) {
      options.forEach(key => {
        if (key.is_required === false) {
          let isRequired = {"value": "Not required", "price": null};
          key.values.unshift(isRequired);
        }
      });
    },
    addAccessoriesToBasket() {
      this.accessoriesForProduct = [];
      Object.keys(this.selectedAccessories).forEach((item) => {
        this.accessoriesForProduct.push({
          sku: this.selectedAccessories[item].accessory.sku,
          quantityPerItem: this.selectedAccessories[item].count,
          quantity: this.selectedAccessories[item].count * this.quantity,
          name: this.selectedAccessories[item].accessory.name,
          desc: (this.selectedAccessories[item].accessory.short_description ? this.selectedAccessories[item].accessory.short_description : '') + ' Accessory for ' + this.product.name + '. Price included in main product.',
          itemPrice: 0,
          itemTax: 0,
          totalPrice: 0,
          totalTax: 0,
          isAccessory: this.product.sku,
          parentId: this.parentId
        })
      });
    },
    removeOption(option) {
      // this.$set(this.selectedOptions, option.name, '');
      this.$delete(this.selectedOptions, option)
    },
    removeAccessory(accessory) {
      Vue.delete(this.selectedAccessories, accessory)
    },

    //help method for get object with attributes keys and empty values
    emptySelection() {
      let obj = {};
      Object.keys(this.availableAttributes).forEach((attr) => {
        obj[attr] = '';
      });
      return obj;
    },
    gaAddToBasket() {
      if(window.dataLayer) {
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': 'GBP',
            'add': {                                // 'add' actionFieldObject measures.
              'products': [{                        //  adding a product to a shopping cart.
                'name': this.product.name,
                'id': this.product.sku,
                'price': this.itemPrice,
                'quantity': this.quantity
              }]
            }
          }
        });
      }
    },
    ga4AddToBasket(){
      gtag('event', 'add_to_cart', {
        currency: "GBP",
        value: this.itemPrice,
        items: [
          {
            item_id: this.product.sku,
            item_name: this.product.name,
            price: this.product.sales_price,
            quantity: this.quantity
          }
        ]
      });
    },
    loadPayPal() {
      loadScript({ "client-id": this.ppClientId,
        currency: 'GBP',
        components: 'messages'
      })
    },
  },
  computed: {
    ...mapState(["scrollY", "vatToggle"]),
      selectedItemPrice() {
        return
      },
      discountedItemPrice() {
        return function(value) {
            if(this.vatToggle){
                return (this.product.sale_price - value) * (1 + this.product.tax_rate/100);
            }
            return this.product.sale_price - value;
        }
      },
    disabled() {
      return !(this.optionsSatisfied && this.accessoriesSatisfied);
    },
    accessoriesSatisfied() {
      let result = true;
      if(this.accessories.length > 0) {
        this.accessories.forEach((accessory) => {
          if(accessory.is_required) {
            return result = Object.keys(this.selectedAccessories).includes(accessory.name);
          }
        });
      }
      return result;
    },
    optionsSatisfied() {
      return this.options.length === Object.keys(this.selectedOptions).length;
    },
    optionsTotal() {
      let optionsTotal = 0;
      Object.keys(this.selectedOptions).forEach((key) => {
        optionsTotal += this.selectedOptions[key].price;
      });
      return optionsTotal;
    },
    accessoriesTotal() {
      let accessoriesTotal = 0;
      Object.keys(this.selectedAccessories).forEach((key) => {
        accessoriesTotal += this.selectedAccessories[key].price * this.selectedAccessories[key].count;
      });
      return accessoriesTotal;
    },
     itemPrice() {
        // todo need to add accessories to product..
        let data = {};
        data.product = this.product;
        data.product.selectedOptions = {...this.selectedOptions};
        data.quantity = this.quantity;
        // console.log('data before send: ', this.product);
      return this.calculateItemPrice(data);
    },
    itemTax() {
      return this.itemPrice * (this.product.tax_rate/100);
    },
   viewPrice() {
      if(!this.vatToggle) {
        return this.itemPrice;
      }
      return this.itemPrice + this.itemTax;
    },
    totalViewPrice() {
      return (!this.viewPrice ? 0 : this.viewPrice) * (!this.quantity ? 1 : this.quantity);
    },
    totalTax() {
      return this.itemTax * (!this.quantity ? 1 : this.quantity);
    },
    totalPrice() {
      return this.itemPrice * (!this.quantity ? 1 : this.quantity);
    },
    animatedPrice() {
      return this.tweenedPrice;
    },
  },
    watch: {
    totalViewPrice(newValue) {
      return TweenLite.to(this.$data, 0.5, {tweenedPrice: newValue});
    },
  },
  async mounted() {
    let form_data = new FormData;
    form_data.append('action', 'yodah_product_selector_query');
    form_data.append('product', this.currentProductId);

    await axios.post(my_ajax_object.ajax_url, form_data)
        .then(response => {
          // console.log(response.data);
          this.product = {...this.product, ...response.data.data};
          let attributes = response.data.data.attributes ? JSON.parse(response.data.data.attributes) : [];
          this.$set(this.product, 'attributes', attributes );
          this.configurations = response.data.data.configurations ? response.data.data.configurations : [];
          this.setupAttributes();
          this.product.images = response.data.data.images ? JSON.parse(response.data.data.images) : [];
          this.product.files = response.data.data.files ? JSON.parse(response.data.data.files) : [];
          this.product.common_files = response.data.data.common_files ? JSON.parse(response.data.data.common_files) : [];
          this.product.shipping = response.data.data.shipping ? JSON.parse(response.data.data.shipping) : [];
          this.product.video = response.data.data.video ? JSON.parse(response.data.data.video) : [];
          this.product.sale_price = Number(response.data.data.sale_price);
          this.product.sales_discounts = response.data.data.sales_discounts ? JSON.parse(response.data.data.sales_discounts) : [];
          this.options = response.data.data.sku ? JSON.parse(response.data.data.options) : [];
          this.accessories = response.data.data.sku ? response.data.data.accessory_groups : [];
          this.options.length > 0 ? this.addNotRequired(this.options) : null;
          this.product.is_sell_online = !!Number(this.product.is_sell_online);
          this.product.min_sale_count = response.data.data.min_sale_count ? Number(response.data.data.min_sale_count) : 1;
          this.$store.commit('updateCurrentProduct', this.product);
          this.quantity = this.product.min_sale_count;
        }).catch(function(error) {
        console.log('Error: ' + error.message + ' on line ' + error.line);
      })
    setTimeout(this.scroll, 250); //todo maybe a better way of doing this
    this.dataReady = true;


    gtag("event", "view_item", {
      currency: "GBP",
      value: this.product.sale_price,
      items: [
        {
          item_id: this.product.sku,
          item_name: this.product.name,
          price: this.product.sale_price,
          quantity: this.quantity
        }
      ]
    });
    if(this.ppClientId) {
      this.loadPayPal();
    }

  }
};
</script>
